import { firebase_config } from '@tminc/util-environment';

export const environment = {
    production: true,
    useEmulators: false,
    firebase: firebase_config,
};
